import React, { useState } from "react";
import { pxToRem } from "@/util/common";
import { createUseStyles } from "react-jss";
import { Button, Image, Toast } from "antd-mobile";
import API from "@/api";
import useCustomTranslation from "@/hooks/useTranslation";

const ApplyProportion: React.FC<{
	scale: number;
	onVisiblePopup: (visible: boolean) => void;
}> = ({ scale, onVisiblePopup }) => {
	const classes = useStyles();
	const { t } = useCustomTranslation();
	const [scaleValue, setScaleValue] = useState(scale ?? 0);

	const handleIncrementDecrement = (amount: number) => {
		setScaleValue((prevValue) => {
			const newValue = prevValue + amount;
			return Math.max(0, Math.min(100, newValue));
		});
	};

	const postUserSetingUpdateHandle = async () => {
		try {
			const params: any = {
				scale: scaleValue,
			};
			const result: any = await API.members.postUserSetingUpdate(params);
			if (result?.code === 0) {
				Toast.show({
					content: t("ApplySuccess"),
					position: "top",
				});
				onVisiblePopup(false);
			}
		} catch (error) {
			console.log("---postUserSetingUpdate--:", error);
		} finally {
			onVisiblePopup(false);
		}
	};

	const onSubmit = () => {
		// 不判相同
		postUserSetingUpdateHandle();
	};
	return (
		<div className={classes.applyProportionWrap}>
			<h2>{t("ApplyProportion")}</h2>
			<div className="inputWrap">
				<Image
					onClick={() => handleIncrementDecrement(-5)}
					src={require("@/assets/images/icons/sub.png")}
					width={32}
					height={32}
				/>
				<div className="inputBox">
					<span>{scaleValue}%</span>
				</div>
				<Image
					onClick={() => handleIncrementDecrement(5)}
					src={require("@/assets/images/icons/add.png")}
					width={32}
					height={32}
				/>
				{/* <Input
					value={value}
					onChange={(val) => {
						setValue(val);
					}}
					style={{
						height: pxToRem(50),
						width: pxToRem(250),
						borderRadius: pxToRem(8),
						"--color": "#FFFFFF",
						"--text-align": "center",
						border: "1px solid #4C66C7",
						backgroundColor: "#181A22",
					}}
				/> */}
			</div>
			<Button
				onClick={onSubmit}
				block
				shape="rounded"
				style={{
					height: pxToRem(50),
					fontSize: pxToRem(16),
					fontWeight: "700",
					"--border-width": "0",
					"--text-color": "#FFFFFF",
					background:
						" linear-gradient(90deg, #4675FF 0%, #0E329D 100%)",
				}}
			>
				{t("Apply")}
			</Button>
		</div>
	);
};

export default ApplyProportion;

const useStyles = createUseStyles({
	applyProportionWrap: {
		padding: {
			left: pxToRem(20),
			right: pxToRem(20),
			bottom: pxToRem(38),
			top: pxToRem(20),
		},
		background: "linear-gradient(to bottom right, #181B24 0, #232C48 100%)",
		"& h2": {
			color: "#FFFBEE",
			fontSize: pxToRem(18),
			fontWeight: "500",
			lineHeight: pxToRem(28),
		},
		"& .inputWrap": {
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			padding: {
				top: pxToRem(15),
				bottom: pxToRem(45),
				left: pxToRem(34),
				right: pxToRem(34),
			},
			"& .inputBox": {
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: pxToRem(50),
				width: pxToRem(154),
				color: "#FFFFFF",
				fontSize: pxToRem(18),
				fontWeight: pxToRem(500),
				borderRadius: pxToRem(8),
				margin: {
					left: pxToRem(14),
					right: pxToRem(14),
				},
				border: "1px solid #4C66C7",
				backgroundColor: "#181A22",
			},
		},
	},
});
